module.exports = __webpack_public_path__ + "static/media/klimor.eb18648b.png";